import { FetchStreetGeoJsonRequest, SetDefaultData } from './map.actions'
import { SearchGisStreetsRequest } from '@shared/shared.actions'
import { getSearchGisStreetsState } from '@shared/shared.select'
import { debounceTime } from 'rxjs/operators'
import { List } from 'immutable'
import { FetchSettingsRequest } from './../settings/settings.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription, Subject } from 'rxjs'

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
})
export class MapComponent implements OnInit, OnDestroy {
  public streets: List<Map<string, any>>
  public onStreetAutocomplete$ = new Subject<string>()
  private streetAutocomplete$: Subscription
  private searchStreetsState$: Subscription
  public streetId: number

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.searchStreetsState$ = this.store
      .pipe(select(getSearchGisStreetsState))
      .subscribe((state) => {
        this.streets = state.get('data').toJS()
      })

    this.streetAutocomplete$ = this.onStreetAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchGisStreetsRequest(keyword))
        }
      })

    this.store.dispatch<any>(new SearchGisStreetsRequest(''))
  }

  ngOnDestroy() {
    this.searchStreetsState$.unsubscribe()
    this.streetAutocomplete$.unsubscribe()
  }

  onStreetChange(id: number) {
    if (id) {
      this.store.dispatch<any>(new FetchStreetGeoJsonRequest(id))
    }
  }

  onStreetClear() {
    this.store.dispatch<any>(new SetDefaultData('streetGeoJson'))
  }
}
